import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class InfrastructureTagsApi extends ApiModule {
	constructor() {
		super(ModulesMap.INFRASTRUCTURE_TAGS, {
			entity: 'infrastructure_tags',
		})
	}
}
